export const WeekEnds_abbr = ["چ", "پ"];
export const WeekEnds = ["چهارشنبه", "پنج‌شنبه"];

export const NormalWeekDays_abbr = ["ج", "ش", "ی", "د", "س"];
export const NormalWeekDays = ["جمعه", "شنبه", "یک‌شنبه", "دوشنبه", "سه‌شنبه"];
